import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

export default function About() {
  const { t } = useLanguage();
  return (
    <section data-testid="about-section" className="relative py-24 md:py-32 radial-gold">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.7 }}
          >
            <div className="text-gold text-sm uppercase tracking-[0.3em] font-semibold mb-4">
              {t.about.eyebrow}
            </div>
            <h2 className="font-heading text-4xl sm:text-5xl md:text-6xl lg:text-7xl text-white leading-[0.95] break-words">
              {t.about.headingStart} <span className="text-gold">{t.about.headingEnd}</span>
            </h2>
            <p className="mt-8 text-white/70 text-base md:text-lg leading-relaxed">{t.about.p1}</p>
            <p className="mt-6 text-white/70 text-base md:text-lg leading-relaxed">{t.about.p2}</p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.7, delay: 0.2 }}
            className="bg-ink-card rounded-lg p-8 md:p-10 border border-ink-line"
          >
            <div className="text-xs uppercase tracking-[0.3em] text-gold mb-6 font-semibold">
              {t.about.capabilitiesTitle}
            </div>
            <ul className="space-y-4">
              {t.about.capabilities.map((c) => (
                <li key={c} className="flex items-start gap-3">
                  <span className="mt-1 w-5 h-5 rounded-full bg-gold flex items-center justify-center shrink-0">
                    <Check size={12} className="text-ink" strokeWidth={3} />
                  </span>
                  <span className="text-white/90 text-base md:text-lg font-medium">{c}</span>
                </li>
              ))}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
